/**
 * Tab and accordian switching script
 *
 * @since 1.0.0
 * @package iastage
 */

(function($) {
    $('.tabs .tab-links a').on('click', function(e)  {
        var currentAttrValue = $(this).attr('href');

        // Show/Hide Tabs
        $('.tabs ' + currentAttrValue).show().siblings().hide();

        // Change/remove current tab to active
        $(this).parent('li').addClass('active').siblings().removeClass('active');

        e.preventDefault();
    });

    $('.accordian .tab').on('click', function() {
    	$(this).toggleClass('open');
    	$(this).find('.job').slideToggle(100, 'linear');
    });

})(jQuery);